import { useContext } from 'react';
import { FaStar, FaRegStar } from "react-icons/fa";
import { AccumulationChartComponent, AccumulationSeriesCollectionDirective, AccumulationSeriesDirective, Inject, PieSeries, AccumulationTooltip, AccumulationDataLabel } from '@syncfusion/ej2-react-charts';
import { ApiContext } from '../../context/ApiContext';
import { DashboardContext } from '../../context/DashboardContext';

export default function Impacto({ corFavorito, tab }) {
    const { ResumoPrioridades } = useContext(ApiContext)
    const { AdicionarGraficoFavorito } = useContext(DashboardContext)
    const onPointRender = (args) => {
        if (args.point.x.indexOf('Normal') > -1) {
            args.fill = '#16A34A';
        } else if (args.point.x.indexOf('Importante') > -1) {
            args.fill = '#FACC15';
        } else if (args.point.x.indexOf('Prioritária') > -1) {
            args.fill = '#F87171';
        }
        else {
            args.fill = '#7f84e8';
        }
    };

    const retornaCor = (descricao) => {
        switch (descricao) {
            case "Normal":
                return "status-concluido"
            case "Importante":
                return "status-prioritario"
            case "Prioritária":
                return "status-atraso"
            default:
                break;
        }
    }

    const ResumoPrioridadesFormatado = ResumoPrioridades && ResumoPrioridades.map(item => ({
        ...item,
        text: `${item.x}: ${item.text}`
    }));

    const tooltipRender = (args) => {
        args.text = `${args.point.x}: <b>${args.point.y}%</b>`;
    };

    return (
        <>
            <h2 className="h2-bsc">
                <button onClick={() => AdicionarGraficoFavorito("Impacto Objetivos do Negócio")} className='btn-grafico'>{corFavorito("Impacto Objetivos do Negócio") ? <FaRegStar /> : <FaStar style={{ color: 'orange' }} />}</button>
                <span style={{ fontWeight: '500' }}>Impacto Objetivos do Negócio</span>
            </h2>
            <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'space-between', alignItems: 'start' }}>
                <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', width: '100%' }}>
                    <AccumulationChartComponent
                        pointRender={onPointRender}
                        tooltip={{ enable: true, enableHtml: true }}
                        tooltipRender={tooltipRender}
                        width='700'
                        height='270'
                        id={`${tab}-impacto`}
                    >
                        <Inject services={[PieSeries, AccumulationTooltip, AccumulationDataLabel]} />
                        <AccumulationSeriesCollectionDirective>
                            <AccumulationSeriesDirective
                                dataSource={ResumoPrioridadesFormatado}
                                yName='y'
                                xName='x'
                                type='Pie'
                                pointColorMapping='fill'
                                border={{ width: "5px" }}
                                innerRadius='60%'
                                dataLabel={{ visible: true, position: 'Outside', name: 'text', font: { fontWeight: '600' }, connectorStyle: { type: 'Curve' } }}
                            >
                            </AccumulationSeriesDirective>
                        </AccumulationSeriesCollectionDirective>
                    </AccumulationChartComponent>
                </div>
                <div className='span-bsc' style={{ display: 'flex', gap: '20px', alignItems: 'center', justifyContent: 'center', width: '100%' }}>
                    {ResumoPrioridades?.map((item, index) => {
                        return (
                            <div key={index} style={{ display: 'flex', alignItems: 'center' }}>
                                <span className={retornaCor(item.x)}></span>
                                <span style={{ marginRight: '5px' }}>{item.x}</span>
                                <span style={{ color: '#A1A1AA', width: '50px' }}>{item.text}</span>
                            </div>
                        )
                    })}
                </div>
            </div>
        </>
    )
}